import browser from "webextension-polyfill";
import { isInHavenExperiment } from "../shared.js";
import { ytHavenLabelWatchingDisable, ytHavenLabelWatchingIgnore, } from "../../shared/index.js";
const manifest = browser.runtime.getManifest();
async function waitForElement(selector) {
    return await new Promise((resolve) => {
        const element = document.querySelector(selector);
        if (element) {
            resolve(element);
            return;
        }
        const observer = new MutationObserver(() => {
            const element = document.querySelector(selector);
            if (element) {
                observer.disconnect();
                resolve(element);
            }
        });
        observer.observe(document.documentElement, {
            childList: true,
            subtree: true,
        });
    });
}
function getWatchingButton() {
    const btn = document.createElement("button");
    btn.style.width = "auto";
    btn.style.height = "100%";
    btn.style.border = "none";
    btn.style.backgroundColor = "transparent";
    btn.style.opacity = "0.9";
    btn.style.color = "inherit";
    btn.style.fontSize = "109%";
    btn.style.cursor = "pointer";
    btn.style.display = "inline-block";
    btn.style.verticalAlign = "top";
    btn.style.margin = "0px 12px";
    btn.addEventListener("mouseover", () => {
        btn.style.opacity = "1";
    });
    btn.addEventListener("mouseout", () => {
        btn.style.opacity = "0.9";
    });
    const btnText = document.createElement("span");
    btnText.textContent = browser.i18n.getMessage("yt_haven_player_watching_with_label", manifest.short_name);
    btnText.style.borderBottom = "2px #e1002d solid";
    btnText.style.paddingBottom = "2px";
    btn.appendChild(btnText);
    return btn;
}
async function start() {
    const isEnabled = await isInHavenExperiment();
    if (!isEnabled || !window.location.hash.includes("yt-haven")) {
        return;
    }
    const controlsContainer = await waitForElement(".ytp-right-controls");
    const watchingBtn = getWatchingButton();
    watchingBtn.addEventListener("click", () => {
        const response = confirm(browser.i18n.getMessage("yt_haven_player_watching_with_confirmation", manifest.short_name));
        const eventName = response
            ? ytHavenLabelWatchingDisable
            : ytHavenLabelWatchingIgnore;
        void browser.runtime.sendMessage({
            type: eventName,
        });
    });
    controlsContainer.insertBefore(watchingBtn, controlsContainer.firstChild);
}
void start();
